import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  { label: 'Privada', value: 'private_company' },
  { label: 'Pública', value: 'public_company' },
]

export const companyKindOptions = optionsToStrategy(options)